import React, {
  Fragment,
  useEffect,
  useRef,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { useParams, Link, useLocation, useHistory } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import Popupchat from "../components/Popupchat";
import Postview from "../components/Postview";
import Lightbox from "react-image-lightbox";
import { useTranslation } from "react-i18next";
import { Tooltip, Fab } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { AddComment } from "@material-ui/icons";
import Createpurepost from "../components/CreatePurepost";
import NoPostYetforUser from "../components/NoPostYetforUser";
import { Helmet } from "react-helmet";
import { SnackbarContext } from "../context/SnackbarContext";
import { useAPI } from "../context/ApiContext";
import { Menu, MenuItem, IconButton } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ShareIcon from "@material-ui/icons/Share";
import DeleteIcon from "@material-ui/icons/Delete";
import ReportIcon from "@material-ui/icons/Report";
import copy from "copy-to-clipboard";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { FaLine, FaTwitter, FaWhatsapp, FaFacebookMessenger } from "react-icons/fa";
import { gaEvent } from "../lib/ga";

const useStyles = makeStyles((theme) => ({
  "@keyframes gradient": {
    "0%": { backgroundPosition: "0% 50%" },
    "50%": { backgroundPosition: "100% 50%" },
    "100%": { backgroundPosition: "0% 50%" },
  },
}));

const PulseStyles = () => (
  <style>{`
    .nl-pulse {
      position: relative;
      box-shadow: 0 0 0 rgba(59,130,246, 0.6);
      animation: nl-pulse 1.8s infinite;
    }
    @keyframes nl-pulse {
      0% { box-shadow: 0 0 0 0 rgba(59,130,246, 0.6); }
      70% { box-shadow: 0 0 0 10px rgba(59,130,246, 0); }
      100% { box-shadow: 0 0 0 0 rgba(59,130,246, 0); }
    }
  `}</style>
);

/** サーバ側のページサイズと合わせる */
const PAGE_SIZE = 20;

const Userpage = () => {
  const { userId } = useParams(); // /user/:userId
    const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const { newSnack } = useContext(SnackbarContext);
  const api = useAPI();

  /* ====== 表示対象ユーザーのプロフィール ====== */
  const [viewProfile, setViewProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  const isMe = useMemo(
    () => !!api.myUserId && api.myUserId === userId,
    [api.myUserId, userId]
  );

  // --- フォロー状態（PeopleCard と同等のロジック） ---
  const derivedFollowingInit = !!viewProfile?.isFollowedByMe;
  const [following, setFollowing] = useState(derivedFollowingInit);
  const [followBusy, setFollowBusy] = useState(false);

  useEffect(() => {
    setFollowing(!!viewProfile?.isFollowedByMe);
  }, [viewProfile?.isFollowedByMe]);

  const handleFollow = async () => {
    if (!api.isAuthenticated) return history.push("/login");
    if (!viewProfile?.userId) return;
    try {
      setFollowBusy(true);
      setFollowing(true); // 楽観更新
      setExtraCounts((prev) => ({
        ...prev,
        followed_count:
          (typeof prev.followed_count === "number" ? prev.followed_count : (viewProfile?.followed ?? 0)) + 1,
      }));
      await api.follow(viewProfile.userId);
    } catch (e) {
      setFollowing(false); // 失敗ロールバック
      setExtraCounts((prev) => ({
        ...prev,
        followed_count: Math.max(
          0,
          (typeof prev.followed_count === "number" ? prev.followed_count : (viewProfile?.followed ?? 0)) - 1
        ),
      }));
      newSnack("error", e?.data?.detail || "フォローに失敗しました");
    } finally {
      setFollowBusy(false);
    }
  };

  const handleUnfollow = async () => {
    if (!api.isAuthenticated) return history.push("/login");
    if (!viewProfile?.userId) return;
    try {
      setFollowBusy(true);
      setFollowing(false); // 楽観更新
      setExtraCounts((prev) => ({
        ...prev,
        followed_count: Math.max(
          0,
          (typeof prev.followed_count === "number" ? prev.followed_count : (viewProfile?.followed ?? 0)) - 1
        ),
      }));
      await api.unfollow(viewProfile.userId);
    } catch (e) {
      setFollowing(true); // 失敗ロールバック
      setExtraCounts((prev) => ({
        ...prev,
        followed_count:
          (typeof prev.followed_count === "number" ? prev.followed_count : (viewProfile?.followed ?? 0)) + 1,
      }));
      newSnack("error", e?.data?.detail || "フォロー解除に失敗しました");
    } finally {
      setFollowBusy(false);
    }
  };


  // ★ 追加: 招待フラグ（?fromInvite=1 で true）
  const fromInvite = useMemo(() => {
    const q = new URLSearchParams(location.search);
    return q.get("fromInvite") === "1";
  }, [location.search]);

  // ★ 追加: フォローボタンを狙う ref
  const followBtnRef = useRef(null);

  // ★ 追加: 招待来訪時は CTA 表示イベントを送って、フォローボタンへスクロール
  useEffect(() => {
    if (!fromInvite) return;
    if (isMe) return;              // 自分自身は対象外
    if (following) return;         // すでにフォロー済みは対象外
    // 見た目強調に合わせてスクロール
    if (followBtnRef.current) {
      setTimeout(() => {
        try {
          followBtnRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch {}
      }, 300);
    }
    try { gaEvent && gaEvent("invite_follow_cta_show", { user_id: userId }); } catch {}
  }, [fromInvite, isMe, following, userId]);

    // ★ 追加: 招待バナー（上部）
    const InviteBanner = () => {
      if (!fromInvite || isMe || following) return null;
      return (
        <div
          className="card shadow-lg border-0 mb-3"
          style={{
            borderRadius: 16,
            background: "linear-gradient(135deg,#0f172a,#1e293b)",
            color: "#fff",
            overflow: "hidden",
          }}
        >
          <div className="card-body d-flex align-items-center p-3 p-sm-4">
            <img
              src={viewProfile?.image || "/assets/images/default_profile.png"}
              alt=""
              className="me-3"
              style={{ width: 56, height: 56, borderRadius: 14, objectFit: "cover", background: "#222" }}
              onError={(e) => { e.currentTarget.src = "/assets/images/default_profile.png"; }}
            />
            <div className="flex-fill">
              <div className="fw-700" style={{ fontSize: 16 }}>
                <strong>{viewProfile?.nickname || userId}</strong>
                <span> さんから招待されました！</span>
              </div>
              <div className="font-xssss" style={{ opacity: 0.9 }}>
                ログイン後にこのユーザーをフォローして、最新の投稿をチェックしましょう。
              </div>
            </div>
            <button
              ref={followBtnRef}
              type="button"
              className="btn btn-sm bg-white text-dark fw-700 ms-2 nl-pulse"
              style={{ borderRadius: 9999 }}
              onClick={async () => {
                if (!api.isAuthenticated) { history.push("/login"); return; }
                await handleFollow();
                try { gaEvent && gaEvent("invite_follow_click", { user_id: userId }); } catch {}
              }}
              disabled={followBusy}
            >
              フォローする
            </button>
          </div>
        </div>
      );
    };

    
  /* ====== 右カラム：About & counts（Profiledetail統合） ====== */
  const [extraCounts, setExtraCounts] = useState({
    following_count: undefined,
    followed_count: undefined,
    community_count: undefined,
  });

   // タブ判定（?tab=...）
 const rawTab = useMemo(() => {
   const q = new URLSearchParams(location.search);
   return (q.get("tab") || "").toLowerCase();
 }, [location.search]);

 const activeTab = useMemo(() => {
   if (rawTab === "nice") return "nice";
   if (rawTab === "bookmarks" && isMe) return "bookmarks";
   return "posts";
 }, [rawTab, isMe]);

 // URL の tab を更新（posts はクエリ削除）
 const setTabInUrl = useCallback((tab) => {
   const q = new URLSearchParams(location.search);
   if (tab === "posts") q.delete("tab");
   else q.set("tab", tab);
   history.push({ pathname: `/user/${userId}`, search: q.toString() });
 }, [history, location.search, userId]);

  // 任意：ApiContext に getFollowerFollowingCounts がある場合だけ使う
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (viewProfile?.userId && typeof api.getFollowerFollowingCounts === "function") {
          const data = await api.getFollowerFollowingCounts(viewProfile.userId);
          if (mounted && data) {
            setExtraCounts({
              following_count: data.following_count,
              followed_count: data.followed_count,
              community_count: data.community_count,
            });
          }
        } else {
          setExtraCounts({ following_count: undefined, followed_count: undefined, community_count: undefined });
        }
      } catch (e) {
        // 取得失敗時は何もせずサイレント（UIは viewProfile の集計で表示継続）
      }
    })();
    return () => { mounted = false; };
  }, [api, viewProfile?.userId]);

  const followingCount = extraCounts.following_count ?? viewProfile?.following ?? 0;
  const followedCount  = extraCounts.followed_count  ?? viewProfile?.followed  ?? 0;
  const postsCount     = viewProfile?.posts ?? undefined; // 任意で表示
  const communityCount = extraCounts.community_count; // 取得できた時だけ表示

  /* ====== 投稿：無限スクロール ====== */
  const PAGE0 = { items: [], page: 0, hasMore: true, loading: false };
  const [listPosts, setListPosts] = useState({ ...PAGE0 });
  const [listNice, setListNice] = useState({ ...PAGE0 });
  const [listBookmarks, setListBookmarks] = useState({ ...PAGE0 });
  const loaderRef = useRef(null);

  /* ====== UI ====== */
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isCreatePostOpen, setCreatePostOpen] = useState(false);
  const openCreateDialog = () => setCreatePostOpen(true);
  const closeCreateDialog = () => setCreatePostOpen(false);

  /* ====== データ取得 ====== */
  const loadProfile = useCallback(async () => {
    if (!userId) return;
    setLoadingProfile(true);
    try {
      const p = await api.getProfile(userId); // GET /users/:userId/profile/
      setViewProfile(p || null);
    } catch (e) {
      setViewProfile(null);
      newSnack("error", e?.data?.detail || "プロフィールの取得に失敗しました");
    } finally {
      setLoadingProfile(false);
    }
  }, [api, userId, newSnack]);

   const pickState = useCallback(() => {
       if (activeTab === "nice") return [listNice, setListNice, (c) => api.getUserNices(userId, { count: c })];
       if (activeTab === "bookmarks") return [listBookmarks, setListBookmarks, (c) => api.getMyBookmarks({ count: c })];
       return [listPosts, setListPosts, (c) => api.getUserPosts(userId, { count: c })];
     }, [activeTab, listPosts, listNice, listBookmarks, api, userId]);
    
     const loadActive = useCallback(async (page) => {
       if (!userId) return;
       const [st, setSt, fetcher] = pickState();
       if (st.loading || !st.hasMore) return;
       setSt((prev) => ({ ...prev, loading: true }));
       try {
         const data = await fetcher(page || 0);
         const list = Array.isArray(data?.res) ? data.res : [];
         const total = typeof data?.totalCount === "number" ? data.totalCount : undefined;
         const loaded = (page + 1) * PAGE_SIZE;
         const nextHasMore = total !== undefined
           ? (list.length > 0 && loaded < total + PAGE_SIZE)
           : (list.length > 0);
         setSt((prev) => ({
           items: page === 0 ? list : [...prev.items, ...list],
           page,
           hasMore: nextHasMore,
           loading: false,
         }));
       } catch (e) {
         setSt((prev) => ({ ...prev, loading: false, hasMore: false }));
         newSnack("error", e?.data?.detail || "投稿の取得に失敗しました");
       }
     }, [pickState, userId, newSnack]);

  // URLのuserIdが変わったら初期化
  useEffect(() => {
    setViewProfile(null);
    setLoadingProfile(true);
    setListPosts({ ...PAGE0 });
    setListNice({ ...PAGE0 });
    setListBookmarks({ ...PAGE0 });
    if (userId) {
      loadProfile();
      // ブクマ直打ち対策：他人のページで ?tab=bookmarks は posts に戻す
      if (!isMe && rawTab === "bookmarks") {
        setTabInUrl("posts");
      } else {
        loadActive(0);
      }
    }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [userId]);

   useEffect(() => {
     const [st] = pickState();
     if (st.items.length === 0 && !st.loading) {
       loadActive(0);
     }
   }, [activeTab, pickState, loadActive]);

  // IntersectionObserver（無限スクロール）
   const currentList = activeTab === "nice"
     ? listNice
     : activeTab === "bookmarks" ? listBookmarks : listPosts;
  
   useEffect(() => {
     const io = new IntersectionObserver(([entry]) => {
       if (entry.isIntersecting && !currentList.loading && currentList.hasMore) {
         const next = (currentList.page || 0) + 1;
         loadActive(next);
       }
     }, { root: null, rootMargin: "0px", threshold: 1.0 });
     const el = loaderRef.current;
     if (el) io.observe(el);
     return () => io.disconnect();
   }, [currentList.loading, currentList.hasMore, currentList.page, loadActive]);

  /* ====== 表示用 ====== */
  const topNickname = viewProfile?.nickname || t("Userpage1") || "User";
  const topImage = viewProfile?.image || null;
  const topCreatedLabel = ""; // created_at がないので見た目だけ維持

  const userIdForLinks = viewProfile?.userId || userId;
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // ===== Share helpers =====
const PUBLIC_ORIGIN = (process.env.REACT_APP_PUBLIC_URL || window.location.origin).replace(/\/+$/,'');
// og は必ず“API系”のオリジンを優先（OG展開の確実性を担保）
const OG_ORIGIN = (process.env.REACT_APP_API_BASE || process.env.REACT_APP_API_URL || PUBLIC_ORIGIN).replace(/\/+$/,'');

// UTMを付与（流入元計測）
const withUtm = (url, {src="share_menu", med="copy", camp="post_share"}={}) => {
  const u = new URL(url);
  u.searchParams.set("utm_source", src);
  u.searchParams.set("utm_medium", med);
  u.searchParams.set("utm_campaign", camp);
  return u.toString();
};

const shareText = (t, raw) => {
  const oneLiner = (raw || "").trim().split("\n")[0].slice(0, 60);
  // 言語別に一言（i18nキーはお好みで）
  const ask = (t("ShareAsk") || "意見ください👇");
  return oneLiner ? `${ask}\n${oneLiner}` : ask;
};

// 各サービスの共有URL（ogURL を使う）
const buildShareTargets = ({ ogURL, title, text }) => {
  const urlEnc = encodeURIComponent(ogURL);
  const textEnc = encodeURIComponent(text || "");
  const titleEnc = encodeURIComponent(title || "");
  return {
    line: `https://line.me/R/msg/text/?${encodeURIComponent((text||title)||"")}%20${urlEnc}`,
    x: `https://twitter.com/intent/tweet?text=${textEnc}&url=${urlEnc}`,
    whatsapp: `https://api.whatsapp.com/send?text=${textEnc}%20${urlEnc}`,
    messenger: `https://www.facebook.com/dialog/send?app_id=87741124305&link=${urlEnc}&redirect_uri=${urlEnc}`, // app_idは汎用。将来差し替え可
  };
};

// Web Share API（使えなければ false）
const tryWebShare = async ({ title, text, url }) => {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return true;
    } catch {
      /* キャンセル等は無視してフォールバック */
    }
  }
  return false;
};

useEffect(() => {
  if (viewProfile?.userId) {
    gaEvent("user_view", { user_id: viewProfile.userId });
  }
}, [viewProfile?.userId]);

  return (
    <Fragment>
      <Helmet>
        <title>{topNickname ? `${topNickname} | Nicelinks` : "Nicelinks | ユーザープロフィール"}</title>
        <meta
          name="description"
          content={
            viewProfile?.caption ||
            "Nicelinksユーザープロフィールページ。経済、ガジェット、スポーツ、先端科学技術など、多彩な情報が集まるNicelinksで、ユーザーのプロフィールを確認できます。"
          }
        />
        <meta property="og:title" content={topNickname ? `${topNickname} | Nicelinks` : "Nicelinks | ユーザープロフィール"} />
        <meta property="og:description" content={viewProfile?.caption || "Nicelinksユーザープロフィールページ。"} />
        <meta property="og:image" content={topImage || "https://nicelinks.net/assets/images/default_profile.png"} />
        <meta property="og:url" content={`https://nicelinks.net/user/${userId}`} />
        <meta property="twitter:title" content={topNickname ? `${topNickname} | Nicelinks` : "Nicelinks | ユーザープロフィール"} />
        <meta property="twitter:description" content={viewProfile?.caption || "Nicelinksユーザープロフィールページ。"} />
        <meta property="twitter:image" content={topImage || "https://nicelinks.net/assets/images/default_profile.png"} />
        <meta property="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Person",
            name: topNickname || "Nicelinks ユーザープロフィール",
            description: viewProfile?.caption || "Nicelinksユーザープロフィールページ。",
            image: topImage || "https://nicelinks.net/assets/images/default_profile.png",
            url: `https://nicelinks.net/user/${userId}`,
          })}
        </script>
      </Helmet>

      <Header />
      <Leftnav />

      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left ps-2 pe-2">
            <div className="row">
              {/* 固定ボタン */}
              <div className={classes.PostButtonContainer}>
              </div>

              {/* 上部カード（従来UI） */}
              <div className="col-xl-12 mb-3">
                <div className="card w-100 border-0 p-0 pt-10 mt-5 bg-white shadow-xss rounded-xxl">
                  <div className="card-body p-0 position-relative">

                  <div className="position-absolute right-0 top-0 me-1">
  <IconButton onClick={(e) => { e.stopPropagation(); handleMenuOpen(e); }}>
    <MoreVertIcon fontSize="small" />
  </IconButton>
</div>

<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
  <MenuItem
    onClick={async () => {
      const ogURL = withUtm(`${OG_ORIGIN}/og/user/${userIdForLinks}`, { src:"share_menu", med:"system_share", camp:"user_share" });
      const title = `${topNickname || "User"} | Nicelinks`;
      const text = shareText(t, viewProfile?.caption || topNickname);
      const ok = await tryWebShare({ title, text, url: ogURL });
      if (ok) {
        // window.ReactGA?.event({category:"share", action:"web_share", label:"user"})
        newSnack("success", t("PostView105") || "共有しました");
      } else {
        copy(ogURL);
        // window.ReactGA?.event({category:"share", action:"copy_fallback", label:"user"})
        newSnack("success", t("PostView106") || "URLをコピーしました");
      }
      handleMenuClose();
    }}
  >
    <ShareIcon fontSize="small" className="me-2" /> {t("PostView107") || "シェアする"}
  </MenuItem>

  {(() => {
    const ogURL = withUtm(`${OG_ORIGIN}/og/user/${userIdForLinks}`, { src:"share_menu", med:"sns", camp:"user_share" });
    const title = `${topNickname || "User"} | Nicelinks`;
    const text = shareText(t, viewProfile?.caption || topNickname);
    const links = buildShareTargets({ ogURL, title, text });
    return (
      <>
      <MenuItem component="a" href={links.line} target="_blank" rel="noopener noreferrer" onClick={handleMenuClose}>
        <FaLine className="me-2" color="#00c300" /> {t("PostView108")}
      </MenuItem>
      <MenuItem component="a" href={links.x} target="_blank" rel="noopener noreferrer" onClick={handleMenuClose}>
        <FaTwitter className="me-2" color="#1DA1F2" /> {t("PostView109")}
      </MenuItem>
      <MenuItem component="a" href={links.whatsapp} target="_blank" rel="noopener noreferrer" onClick={handleMenuClose}>
        <FaWhatsapp className="me-2" color="#25D366" /> {t("PostView110")}
      </MenuItem>
      <MenuItem component="a" href={links.messenger} target="_blank" rel="noopener noreferrer" onClick={handleMenuClose}>
        <FaFacebookMessenger className="me-2" color="#0084FF" /> {t("PostView111")}
      </MenuItem>
      </>
    );
  })()}

  <MenuItem
    onClick={() => {
      const ogURL = withUtm(`${OG_ORIGIN}/og/user/${userIdForLinks}`, { src:"share_menu", med:"copy", camp:"user_share" });
      copy(ogURL);
      // window.ReactGA?.event({category:"share", action:"copy", label:"user"})
      newSnack("success", t("PostView106") || "URLをコピーしました");
      handleMenuClose();
    }}
  >
    <i className="feather-copy me-2" /> {t("PostView112") || "リンクをコピー"}
  </MenuItem>

  <MenuItem
    component="a"
    href={`${PUBLIC_ORIGIN}/user/${userIdForLinks}`}
    target="_blank"
    rel="noopener noreferrer"
    onClick={handleMenuClose}
  >
    <OpenInNewIcon fontSize="small" className="me-2" /> {t("UserPage101") || "プロフィールを開く"}
  </MenuItem>

  {!isMe && (
  <MenuItem
    onClick={async () => {
      if (!api.isAuthenticated) {
        newSnack("error", t("UserPage102"));
        handleMenuClose();
        return;
      }
      await api.blockUser(userIdForLinks);
      newSnack("success",t("UserPage103"));
      handleMenuClose();
    }}
  >
    <i className="feather-slash me-2" /> {t("UserPage104")}
  </MenuItem>
)}
<MenuItem
  onClick={async () => {
    if (!api.isAuthenticated) {
      newSnack("error", t("UserPage105"));
      handleMenuClose();
      return;
    }
    await api.reportUser(userIdForLinks, "不適切");
    newSnack("success", t("UserPage106"));
    handleMenuClose();
  }}
>
  <ReportIcon fontSize="small" className="me-2" /> {t("UserPage107")}
</MenuItem>
</Menu>



                    {/* アバター拡大 */}
                    <div>
                      {isOpenModal && topImage && (
                        <Lightbox mainSrc={topImage} onCloseRequest={() => setIsOpenModal(false)} />
                      )}
                      <div onClick={() => topImage && setIsOpenModal(true)}>
                        <figure className="avatar position-absolute w100 z-index-1" style={{ top: "-40px", left: "30px" }}>
                          <img
                            src={topImage || "https://nicelinks.net/assets/images/default_profile.png"}
                            alt="avatar"
                            className="float-right p-1 bg-white rounded-circle w-100"
                          />
                        </figure>
                      </div>
                    </div>

                    <h4 className="fw-700 font-sm mt-2 mb-lg-5 mb-4 pl-15">
                      {topNickname}
                      <span className="fw-500 font-xssss text-grey-500 mt-1 mb-3 d-block">{topCreatedLabel}</span>
                    </h4>
                    

                    {isMe ? (
                      <div className="position-absolute bottom-1 mt-1 right-15">
                        <Link to="/settings">
                          <button className="pointer mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ls-3 d-inline-block rounded-xl  font-xsssss fw-700 ls-lg text-grey-600 d-flex">
                            <i className="feather-settings text-grey-500 mt-0  font-lg"></i>
                          </button>
                        </Link>
                      </div>
                    ) : (
                      <div className="position-absolute bottom-1 mt-2 right-15">
                      {!following ? (
                        <button
                          ref={followBtnRef} // ★ 追加
                          className={`mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white ${fromInvite ? "nl-pulse" : ""}`} // ★ 追加: fromInvite でパルス
                          onClick={handleFollow}
                          disabled={followBusy}
                        >
                          {t("RecommenduserEach2") || "フォロー"}
                        </button>
                      ) : (
                        <button
                          className="mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ms-1 ls-3 d-inline-block rounded-xl bg-grey font-xsssss fw-700 ls-lg text-white"
                          onClick={handleUnfollow}
                          disabled={followBusy}
                        >
                          {t("RecommenduserEach3") || "フォロー中"}
                        </button>
                      )}
                    </div>
                    )}

                  </div>

                  {/* タブ */}
                  <div className="card-body d-block w-100 shadow-none mb-0 p-0 border-top-xs">
                  <ul className="nav nav-tabs h55 d-flex product-info-tab border-bottom-0 ps-4" role="tablist">
           <li className="list-inline-item me-5">
             <span
               role="button"
               onClick={() => setTabInUrl("posts")}
               className={`fw-700 font-xssss pt-3 pb-3 ls-1 d-inline-block ${activeTab==='posts' ? 'text-grey-900' : 'text-grey-500'}`}
             >
               {t("Userpage2") || "投稿"}
             </span>
           </li>
           <li className="list-inline-item me-5">
             <span
               role="button"
               onClick={() => setTabInUrl("nice")}
               className={`fw-700 font-xssss pt-3 pb-3 ls-1 d-inline-block ${activeTab==='nice' ? 'text-grey-900' : 'text-grey-500'}`}
             >
               {t("Userpage7") || "Nice"}
             </span>
           </li>
           {isMe && (
             <li className="list-inline-item me-5">
               <span
                 role="button"
                 onClick={() => setTabInUrl("bookmarks")}
                 className={`fw-700 font-xssss pt-3 pb-3 ls-1 d-inline-block ${activeTab==='bookmarks' ? 'text-grey-900' : 'text-grey-500'}`}
               >
                 {t("Userpage3") || "ブックマーク"}
               </span>
             </li>
           )}
         </ul>
                  </div>
                </div>
              </div>

              {/* 右カラム：Profiledetailを統合 */}
              <div className="col-xl-4 col-xxl-3 col-lg-4 pe-3">

                {/* === Profiledetail 相当（統合） === */}
                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                  <div className="card-body d-block p-4">
                    <h4 className="fw-700 mb-3 font-xsss text-grey-900">About</h4>
                    <p className="fw-500 text-grey-500 lh-24 font-xssss mb-0" style={{ whiteSpace: "pre-wrap" }}>
                      {viewProfile?.caption || ""}
                    </p>
                  </div>

                  {/* フォロー */}
                  <div className="card-body d-flex pt-0">
                    <i className="feather-user text-grey-500 me-3 font-lg"></i>
                    <Link to={`/connections?user_id=${encodeURIComponent(userIdForLinks || "")}&tab=following`}>
                      <h4 className="fw-700 text-grey-600 font-xssss mt-1 pointer">
                        {followingCount} {t("Profiledetail2") /* フォロー */ || "フォロー"}
                      </h4>
                    </Link>
                  </div>

                  {/* フォロワー */}
                  <div className="card-body d-flex pt-0">
                    <i className="feather-user text-grey-500 me-3 font-lg"></i>
                    <Link to={`/connections?user_id=${encodeURIComponent(userIdForLinks || "")}&tab=followers`}>
                      <h4 className="fw-700 text-grey-600 font-xssss mt-1 pointer">
                        {followedCount} {t("Profiledetail1") /* フォロワー */ || "フォロワー"}
                      </h4>
                    </Link>
                  </div>

                  {/* コミュニティ（取得できたときだけ表示） */}
                  {typeof communityCount === "number" && (
                    <div className="card-body d-flex pt-0">
                      <i className="feather-users text-grey-500 me-3 font-lg"></i>
                      <Link to={`/communitylist?user_id=${encodeURIComponent(userIdForLinks || "")}`}>
                        <h4 className="fw-700 text-grey-600 font-xssss mt-1 pointer">
                          {communityCount} {t("Profiledetail3") /* コミュニティ */ || "コミュニティ"}
                        </h4>
                      </Link>
                    </div>
                  )}

                  {/* 任意: 投稿数も見せたい場合 */}
                  {typeof postsCount === "number" && (
                    <div className="card-body d-flex pt-0">
                      <i className="feather-edit text-grey-500 me-3 font-lg"></i>
                      <div className="fw-700 text-grey-600 font-xssss mt-1">
                        {postsCount} {t("Userpage2") || "投稿"}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* 左カラム：投稿リスト */}
              <div className="col-xl-8 col-xxl-9 col-lg-8">

              {currentList.items.map((post, index) => (
                  <Fragment key={post.postId || post.id || `idx-${index}`}>
                    <Postview
                      postData={post}
                      profileData={post.profile}
                      repostingProfileData={post.repostingProfile || null}
                      commentedCounts={post.commentedCount}
                      repostedTimes={post.repostedCount}
                      likedTimes={post.niceCount}
                    />
                  </Fragment>
                ))}

                {/* 無限スクロールターゲット */}
                <div ref={loaderRef} style={{ height: "20px", margin: "0 auto" }} className="mb-5" />

                {/* ローディング or 0件 */}
                {currentList.loading && (
                  <div className="card-body p-0 mb-3">
                    <div className="card w-100 shadow-xss rounded-xxl border-0 p-4 mb-3">
                      <div className="snippet mt-2 ms-auto me-auto" data-title=".dot-typing">
                        <div className="stage"><div className="dot-typing" /></div>
                      </div>
                    </div>
                  </div>
                )}
                {!currentList.loading && currentList.items.length === 0 && <NoPostYetforUser />}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popupchat />
      <Appfooter />
    </Fragment>
  );
};

export default Userpage;
